<body class="ltr leftmenu">
  <form autocomplete="off" novalidate>
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">
          <div class="row row-sm" *ngIf="list">
            <div class="col-lg-12">
              <div class="card custom-card">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="logo-small mr-2" />
                        <div class="title-container">
                          <h3 class="main-content-label mb-1">
                            <b>{{
                              "header.TeacherEligibility.title" | translate
                              }}</b>
                          </h3>
                          <p class="text-muted card-sub-title mb-0">
                            {{
                            "header.TeacherEligibility.subtitle" | translate
                            }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2"></div>
                    <!-- spacer -->

                    <div class="col-md-3" [formGroup]="teacherAssignForm">
                      <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>{{
                          "header.TeacherEligibility.table.Search" | translate
                          }}
                        </mat-label>
                        <input matInput placeholder="Search" (keyup)="keypress()" formControlName="SearchString" />

                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="col-md-1 prpl">
                      <button id="New" type="button" class="btn btn-primary btn-icon-text mt-1"
                        (click)="addNewRecord()">
                        <span style="display: flex; align-items: center">
                          <img width="20vh" src="../../assets/img/plus.gif" style="margin-right: 5px" />
                          {{
                          "header.TeacherEligibility.table.AddNewRecord"
                          | translate
                          }}
                        </span>
                      </button>
                    </div>
                  </div>
                  <hr class="mt-2" />
                  <div class="table-responsive table-container">
                    <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th>
                            {{
                            "header.TeacherEligibility.table.FcDesc"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.CoName"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.SubName"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.Designation"
                            | translate
                            }}
                          </th>
                          <!-- Add Course Level Column HERE - After Designation -->
                          <th>
                            {{
                            "header.TeacherEligibility.table.CourseLevel"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.Experience"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.Count"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.District"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.IsRepeat"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.TeacherType"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.IsHOD"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.IsSameCollege"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.IsBothTeachType"
                            | translate
                            }}
                          </th>
                          <th>
                            {{
                            "header.TeacherEligibility.table.Guide"
                            | translate
                            }}
                          </th>
                            <th>
                            {{
                            "header.TeacherEligibility.table.IsNotSameDistirct"
                            | translate
                            }}
                          </th>
                          <th class="text-center">
                            {{
                            "header.TeacherEligibility.table.Action"
                            | translate
                            }}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let row of collegedataList">
                          <td>{{ row.FcDesc }}</td>
                          <td>{{ row.CoName }}</td>
                          <td>{{ row.SubName }}</td>
                          <td>
                            {{
                            row.Designation === "INT"
                            ? "Internal"
                            : row.Designation === "EXT"
                            ? "External"
                            : row.Designation === "CP"
                            ? "Chair Person"
                            : row.Designation
                            }}
                          </td>
                          <td>
                            {{ getCourseLevelDescription(row.CourseLevel || row.CoLevel) }}
                          </td>
                          <td>{{ row.Experience }}</td>
                          <td>{{ row.Count }}</td>
                          <td>{{ row.District }}</td>
                          <td>{{ row.Is_Repeat === true || row.Is_Repeat === 1 ? "Yes" : "No" }}</td>
                          <td>{{ row.TeacherType }}</td>
                          <td>{{ row.IsHOD === 1 ? "Yes" : "No" }}</td>
                          <td>{{ row.IsSameCollege === 1 ? "Yes" : "No" }}</td>
                          <td>{{ row.IsBothTeachType === 1 ? "Yes" : "No" }}</td>
                          <td>{{ row.Guide === 1 ? "Yes" : "No" }}</td>
                          <td>{{ row.IsNotSameDistirct === 1 ? "Yes" : "No"}}</td>

                          <td class="text-center">
                            <a class="floating mr-2 pr-3" title="Edit" (click)="editData(row)">
                              <i class="fa fa-edit"></i>
                            </a>
                            <!-- <a
                              class="ml-2 floating"
                              title="Delete"
                              (click)="deleteData(row)"
                            >
                              <i class="fas fa-trash"></i>
                            </a> -->
                          </td>
                        </tr>

                        <tr *ngIf="collegedataList?.length === 0">
                          <td colspan="15" class="text-center text-muted">
                            No records found
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="onPageChange($event)"></mat-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</body>